<form [formGroup]="form" (submit)="handleSubmit($event)">
    @for (conf of config(); track $index) {
        <ng-container dynamicField [config]="conf" [group]="form"></ng-container>
    }
</form>
